// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".transition1063-container[data-v-d3383ba2]{background-color:#ff56b1;position:relative}.transition1063-container .scroll-bg[data-v-d3383ba2]{bottom:0;left:0;position:absolute;width:100%}.transition1063-container .one[data-v-d3383ba2]{background-color:#ff56b1;height:0}.transition1063-container .two[data-v-d3383ba2]{height:0}@media screen and (max-width:1199px){.transition1063-container[data-v-d3383ba2]{display:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
